import { TrackInfo } from "../../model/track-info";
import { TrackActionResult } from "../../model/track-action-result";
import { RegistratioData } from "src/app/shared/model/registration-data";

export class OriginIncomeInvestAction {

    public static execute(data: RegistratioData, track: TrackInfo[]): TrackActionResult {
        const id = data.professionalData.originIncome;
        const income: string = data.incomeEquity?.income;
        const patrimony: string = data.incomeEquity?.patrimony;

        if (id === '11833') {
            const trackInfo = !income || !patrimony || income === '0.00' || income === '' || patrimony === '0.00' || patrimony === ''
            ? new TrackInfo('income-wealthincome', ['income', 'income-wealthincome'])
            : undefined;
            return new TrackActionResult(data, trackInfo);
        } else {
            const trackInfo = new TrackInfo('company-cnpj', ['professional-data', 'company-cnpj']);
            return new TrackActionResult(data, trackInfo);
        }
    }

}